module.exports = __webpack_public_path__ + "static/media/yearOfConstruction.660a536f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/characteristics/yearOfConstruction.svg
// module id = 874
// module chunks = 0